export const mongoUrl = 'http://localhost:5173/fileupload/files/';
//export const mongoUrl = 'https://ct-onlinq.herokuapp.com/fileupload/files/';
//export const mongoUrl = 'https://ct-onlinq-platform.onrender.com/fileupload/files/'; 
//export const mongoUrl = 'https:ct-onlinq.iitkgp.ac.in/fileupload/files/'